import React from "react";
import _ from "lodash";

// Select component
export const Select = React.forwardRef(
    (
        {
            label,
            id,
            name,
            placeholder = "Select an option",
            disabled = false,
            required = false,
            isHideLabel = false,
            className = "",
            subTitle = "",
            subRequired = false,
            errors = null,
            loading = false,
            errorName = "",
            options = [],
            schema = { name: "label", value: "value" },
            isHideDefault = false,
            ...props
        },
        ref
    ) => {
        const msg = _.get(errors || {}, errorName || name);

        return (
            <div className="w-full font-urbanist">
                {(!!label || !isHideLabel) && (
                    <label
                        htmlFor={id}
                        className={`block text-lg font-semibold mb-1 ${disabled ? "text-gray-500" : "text-white"}`}
                    >
                        {label} {required && <span className="text-red-600">*</span>}
                    </label>
                )}
                {
                    !!subTitle &&
                    <p className="text-xs text-gray-400 mb-1">
                        {subTitle}
                        {subRequired && <span className="text-red-600">*</span>}
                    </p>
                }
                <div className="relative">
                    <select
                        ref={ref}
                        id={id}
                        name={name}
                        disabled={loading || disabled}
                        required={required}
                        placeholder={placeholder}
                        className={`bg-[#22262E] border border-gray-700 rounded-lg w-full py-2 px-3 text-gray-400 focus:outline-none focus:ring-2 focus:ring-white ${disabled ? "cursor-not-allowed opacity-60" : ""
                            } ${className}`}
                        {...props}
                    >
                        {(!isHideDefault) && (
                            <option value="">
                                {placeholder || label}
                            </option>
                        )}
                        {options.map((option, index) => {
                            const optionValue = typeof option === 'object' ? _.get(option, schema?.value) : option;
                            const optionLabel = typeof option === 'object' ? _.get(option, schema?.name) : option;
                            const optionDisabled = typeof option === 'object' ? option.disabled : false;

                            return (
                                <option
                                    key={optionValue || index}
                                    value={optionValue}
                                    disabled={optionDisabled}
                                >
                                    {optionLabel}
                                </option>
                            );
                        })}
                    </select>
                    {/* ✅ Right-side loader spinner */}
                    {loading && (
                        <span
                            className="absolute z-10 w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2 right-3 top-2"
                        ></span>
                    )}
                </div>
                {
                    !!msg &&
                    <div className="text-red-700 text-sm md:text-md mt-2">{msg}</div>
                }
            </div>
        )
    }
);